import * as React from 'react';
import {
  ForwardedRef,
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
} from 'react';

import clsx from 'clsx';

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  height?: number;
}

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  (
    { className, height = 22, value, ...props },
    ref: ForwardedRef<HTMLTextAreaElement>,
  ) => {
    const updateHeight = (textArea: HTMLElement) => {
      textArea.style.height = '1px';
      const scrollHeight = textArea.scrollHeight;
      textArea.style.height = height + scrollHeight + 'px';
    };

    let textareaRef = useRef<HTMLTextAreaElement | null>(null);

    useImperativeHandle(ref, () => textareaRef.current!);

    useEffect(() => {
      if (textareaRef.current) {
        updateHeight(textareaRef.current);
      }
    }, [value]);

    return (
      <textarea
        className={clsx(
          className,
          'bg-background placeholder:text-muted-foreground focus-visible:ring-ring overflow-y-hidden rounded-md border px-3 py-2 text-sm focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50',
        )}
        ref={textareaRef}
        value={value}
        onKeyDown={(e) => {
          updateHeight(e.target as any);
        }}
        onKeyUp={(e) => {
          updateHeight(e.target as any);
        }}
        onResize={(e) => {
          console.log(e);
        }}
        onDrag={(e) => {
          console.log(e);
        }}
        {...props}
      />
    );
  },
);
Textarea.displayName = 'Textarea';

export { Textarea };
